export function generateInitials(firstName: string, lastName: string): string {
  const f = firstName?.trim()?.charAt(0).toUpperCase() ?? '';
  const l = lastName?.trim()?.charAt(0).toUpperCase() ?? '';

  return f + l;
}
